import { useTheme } from "@emotion/react";
import { Box, Grid } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { School } from "types/School";
import Header from "./Header";
import { DataGrid, GridToolbar, GridValueGetter } from "@mui/x-data-grid";
import { setAdminState } from "state/adminSlice";
import { useDispatch } from "react-redux";

export interface SchoolGridProps {
  data: Array<School> | undefined;
  isLoading: boolean;
  displayHeader: boolean;
}

const SchoolGrid = ({ data, isLoading, displayHeader }: SchoolGridProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleRowClick = (params: any) => {
    console.log(params.id, params.row.name);
    let id = params?.id || 0;
    let name = params?.row?.name || "";
    // save this to the admin state redux
    console.log("Setting Admin State. School Id: ", id, " School Name: ", name);
    dispatch(setAdminState({ schoolId: id, schoolName: name }));
    navigate(`/dashboard`);
  };

  const columns = [
    { field: "name", headerName: "Name", flex: 0.5 },
    {
      field: "schoolStrength",
      headerName: "Students",
      flex: 0.5,
      valueGetter: (value: any, row: any) => {
        return row.aggregateData?.schoolStrength;
      },
    },
    {
      field: "testsTaken",
      headerName: "Tests Taken",
      flex: 0.5,
      valueGetter: (value: any, row: any) => {
        return row.aggregateData?.testTaken;
      },
    },
    {
      field: "overallPerformance",
      headerName: "Overall Performance",
      flex: 0.5,
      valueGetter: (value: any, row: any) => {
        return row.aggregateData?.overallPerformance;
      },
    },
    { field: "city", headerName: "City", flex: 0.5 },
    { field: "state", headerName: "State", flex: 0.5 },
  ];

  return (
    <Box m="1.5rem 2.5rem">
      {displayHeader && <Header title="Schools" subtitle="List of Schools" />}
      <Box mt="40px" height="75vph">
        <DataGrid
          loading={isLoading || !data}
          rows={data || []}
          columns={columns}
          getRowId={(row) => row.id}
          onRowClick={handleRowClick}
          slots={{ toolbar: GridToolbar }}
        />
      </Box>
    </Box>
  );
};

export default SchoolGrid;
